export default {
  dashboard: 'access/',
  administration: 'administration/',
  registry: 'registry/',
  registryOrganizations: 'registry/organizations',
  registryOrganizationDetails: 'registry/organization/',
  registration: 'access/registration/',
  organizationList: 'administration/organizations',
  organizationDetails: 'administration/organization/',
  roleDetails: 'administration/roles/#ovlascenja',
  roleList: 'administration/roles/',
  roleCreate: 'administration/roles/#lokalne-uloge',
  userDetails: 'administration/users/#rad-sa-korisnicima',
  userList: 'administration/users/',
  userCreate: 'administration/users/#kreiranje-korisnika',
  userProfile: 'administration/user-profile/',
  projectList: 'projects/',
  projectCreate: 'projects/#kreiranje-projekta',
  // If phase or subtab exists it will display slash (/) as prefix
  // Phase value will be display only for 'phases' tab
  // Modify text in projectPhases, projectTabs and projectSubTabs lists
  projectDetails: 'projects/{tab}{phase}{subTab}',
  projectFormPifMini: 'projects/forms/pif-mini/',
  projectFormPreImplementation: 'projects/forms/preimplementation/',
  projectFormPlan: 'projects/forms/implementation-plan/',
  projectFormReporting: 'projects/forms/quartal/',
  projectFormRationalization: 'projects/forms/rationalization/',
  projectFormConclusion: 'projects/forms/ending/',
  projectFormEffects: 'projects/forms/effects/',
  projectFormIdea: 'projects/forms/idea/',
  projectFormPreparedness: 'projects/forms/preparedness/',
  projectFormProjectIdentification: 'projects/forms/projectIdentification/',
  projectFormImportant: 'projects/forms/important/',
  // Modify text in projectLists lists
  projectListsList: 'administration/project-lists/{listName}',
  projectLists: [
    { value: 1, text: '#predlog-za-racionalizaciju' },
    { value: 2, text: '#racionalizacija' },
    { value: 3, text: '#ideja' },
    { value: 4, text: '#projektna-identifikacija' },
    { value: 5, text: '#spremnost' },
    { value: 6, text: '#korekcija' }
  ],
  projectTabs: [
    { value: 'details', text: 'details/' },
    { value: 'phases', text: 'phases/' },
    { value: 'documents', text: 'documents/' },
    { value: 'options', text: 'options' }
  ],
  projectSubTabs: [
    { value: 'forms', text: '' },
    { value: 'activities', text: '' },
    { value: 'successKeyIndicators', text: '' },
    { value: 'organizations', text: '#posmatraci' },
    { value: 'appropriations', text: '#aproprijacije' },
    { value: 'settings', text: '#podesavanja' },
    { value: 'merging', text: '#merging' },
    { value: 'lists', text: '#lists' }
  ],
  projectPhases: [
    { value: 'idea', text: 'idea/' },
    { value: 'projectidentification', text: 'projectidentification/' },
    { value: 'preparedness', text: 'preparedness/' },
    { value: 'important', text: 'important/' },
    { value: 'plan', text: 'plan/' },
    { value: 'correction', text: 'correction/' },
    { value: 'correctionreporting', text: 'correctionreporting/' },
    { value: 'reporting', text: 'reporting/' },
    { value: 'rationalization', text: 'rationalization/' },
    { value: 'conclusion', text: 'conclusion/' },
    { value: 'effects', text: 'xpost/' },
    { value: 'identification', text: 'identification/' },
    { value: 'identification', text: 'identification/' },
    { value: 0, text: 'idea/' },
    { value: 1, text: 'projectidentification/' },
    { value: 2, text: 'preparedness/' },
    { value: 3, text: 'important/' },
    { value: 4, text: 'plan/' },
    { value: 5, text: 'reporting/' },
    { value: 13, text: 'rationalization/' },
    { value: 7, text: 'conclusion/' },
    { value: 8, text: 'xpost/' },
    { value: 10, text: 'identification/' },
    { value: 11, text: 'correction/' },
    { value: 12, text: 'correctionreporting/' }
  ]
}
